module.exports = __webpack_public_path__ + "img/single_family.2a2f420e.svg";